//@ts-nocheck
import React from "react";
import { NumericFormat } from 'react-number-format'
import { getUnitPrice } from "../../../lib/utils";

export default function Price(props) {
  const { children, separator = ",", ...other } = props;

  const priceVal = getUnitPrice({ price: children });

  return (
    <NumericFormat value={priceVal} thousandSeparator={separator} {...other} />
  );
}
